import * as tf from '@tensorflow/tfjs-core';
export function scale(x, params) {
    return tf.add(tf.mul(x, params.weights), params.biases);
}
//# sourceMappingURL=scaleLayer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/face-api.js/build/es6/faceRecognitionNet/scaleLayer.js
// module id = 5126
// module chunks = 0